export class GetChatHistoryModel {
    public SubscriberChatId: string;
    public SubscriberId: string;
    public EventId: string;
}
